import { Markup } from "interweave";
import { DictionaryLink, HTMLBlock, Sentence } from "../../../rest/models";
import { RenderSentence } from "./RenderSentence";
import { groupBy } from "../../../utils";
import { useAppSelector } from "../../../store/hooks";
import { EWRBlockEditor } from "./editwhilereading/EWRBlockEditor";
import { useState } from "react";
import { Button } from "../../RequestRespectingInputs";

export function RenderBlock(props: Props)
{
    const b = props.block;
    const dl = props.dict_links;

    const state = useAppSelector(function(state)
    {
        const sbr = state.bookReader;
        return (
        {
            childBlocks: sbr.blocksByParent[b.block_id],
            blocksOnPage: sbr.pagination.blocks,

            sentencesForBlock: sbr.sentencesByBlock[b.block_id],
            sentencesOnPage: sbr.pagination.sentences,
        });
    });

    const {childBlocks, blocksOnPage, sentencesForBlock, sentencesOnPage} = state;

    const childBlocksToShow = childBlocks?.filter(b => blocksOnPage[b.block_id]) ?? [];
    const sentences = sentencesForBlock?.filter(s => s.sentence_id >= sentencesOnPage.first && s.sentence_id < sentencesOnPage.last) || [];
    
    const [collapsed, setCollapsed] = useState(false);
    const [rawMarkupHTMLCollapsed, setRawMarkupCollapsed] = useState(true);

    const sentencesByType = groupBy(sentences, s => s.type);
    
    function sentencesToElm(sentences: Sentence[] | null, headerText: string)
    {
        return sentences?.length
        ? <fieldset>
            <legend>
                {headerText}
            </legend>
            {sentences.map(s => <RenderSentence
                                    key={s.key}
                                    sentence={s}
                                    dictLinks={dl}
                                    isPreview={props.isPreview}/>)}
            </fieldset>
        : <></>;
    }
    
    function blockToElm(b: HTMLBlock)
    {
        return <RenderBlock
                key={b.key}
                block={b}
                dict_links={props.dict_links}
                isPreview={props.isPreview}/>;
    }

    //If the block is a container block, has no sentences and only one child block, print only the child block HTML.
    if (b.type === 'c' && !sentences?.length && childBlocksToShow.length === 1)
    {
        return blockToElm(childBlocksToShow[0]);
    }

    let rawMarkupHTML = <></>;
    if (b.html)
    {
        let rmhc = rawMarkupHTMLCollapsed;
        rawMarkupHTML = b.type === 'n'
            ? sentencesToElm(sentencesByType['n'], 'Original HTML:')
            : <fieldset>
                    <legend>
                        Original HTML:
                        <Button onClick={e => setRawMarkupCollapsed(!rmhc)}>{rmhc ? '►' : '▼'}</Button>
                    </legend>
                    {rmhc ? null : <Markup content={b.html}/>}
            </fieldset>;
    }

    const titleTextHTML = sentencesToElm(sentencesByType['t'], 'Title text:');
    const altTextHTML = sentencesToElm(sentencesByType['a'], 'Alt text:');
    const sentencesHTML = sentencesToElm(sentencesByType['p'], 'Sentences:');

    const childBlocksHTML = childBlocksToShow.length
    ? <fieldset className='ernots_ChildBlockContainer'>
        <legend>Child blocks:</legend>
        {childBlocksToShow.map(blockToElm)}
      </fieldset>
    : <></>;

    const blockEditor = !props.isPreview && b.parent_block_id >= 0
    ? <EWRBlockEditor block={b}/>
    : <></>;

    return (
    <fieldset className='ernots_RenderBlock'>
        <legend>
            Block #{b.block_id + 1}
            <Button onClick={e => setCollapsed(!collapsed)}>{collapsed ? '►' : '▼'}</Button>
        </legend>
        {collapsed ? null : <>
            {rawMarkupHTML}
            {altTextHTML}
            {titleTextHTML}
            {sentencesHTML}
            {childBlocksHTML}
            {blockEditor}
        </>}
    </fieldset>);
}

interface Props
{
    block: HTMLBlock;
    dict_links: {[language_id: string]: DictionaryLink[]};
    isPreview: boolean;
}